import React from 'react'
import TextField from '../fields/TextField'
import { FormElementProps } from './FormElementParts'

const DateElement: React.FC<FormElementProps> = ({
  disabled,
  errorText,
  isRequired,
  label,
  name,
  onChange,
  placeholder,
  type,
  value,
}) => {
  const callChange = React.useCallback(
    (val) => {
      if (onChange) {
        onChange({ name, value: val })
      }
    },
    [name, onChange],
  )
  const handleChange = (e) => {
    e.preventDefault()
    callChange(e.target.value)
  }
  return (
    <TextField
      disabled={disabled}
      id={name}
      label={label}
      name={name}
      onChange={handleChange}
      placeholder={placeholder ?? undefined}
      required={isRequired}
      serverErrors={name && errorText ? { [name]: errorText } : undefined}
      type={type}
      value={value ?? ''}
    />
  )
}

export default DateElement
